import * as React from 'react';
export const IcServerCloud = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 9a2 2 0 00-1.75 1.05A.94.94 0 0016 11a2 2 0 000 4h4a2 2 0 001-3.74c.01-.086.01-.174 0-.26a2 2 0 00-2-2zM5.5 11h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
